import React from 'react';
import ServiceDetailTemplate from '../Elements/ServiceDetailTemplate';

const bnrimg = require('../../images/admin.jpg');
const productImg = require('../../images/Presupuestos.png');

const ServiceDetailPresupuestos = () => (
    <ServiceDetailTemplate
        moduleKey="presupuestos"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default ServiceDetailPresupuestos;
